import RemoteSprite from "../Common/RemoteSprite";
import UIManager from "../Shared/UIManager";
import NetworkLogic from "../Shared/NetworkLogic";
import EnterSoundManager from "../Shared/EnterSoundManager";
import Player from "../Models/Player";

const {ccclass, property} = cc._decorator;

@ccclass
export default class FixToolUI extends cc.Component {
    @property(cc.Node)
    nodeContent: cc.Node = null
    
    @property(cc.Node)
    nodeTemplate: cc.Node = null

    onLoad () {
        this.nodeTemplate.parent = null
    }

    start () {
        UIManager.showLoadingUI()
        NetworkLogic.getFixData(function (data) {
            UIManager.hideLoadingUI()
            data.forEach(item => {
                if (item.showType === 0 || (item.showType === 1 && cc.sys.os === cc.sys.OS_ANDROID) || (item.showType === 2 && cc.sys.os === cc.sys.OS_IOS)) {
                    // 马甲包需要登录且充过值用户才能显示
                    if (item.type === 0 && Player.getPy("money") === 0) {
                        return
                    }

                    let node = cc.instantiate(this.nodeTemplate)
                    node.getChildByName("icon").getComponent(RemoteSprite).url = item.iconSrc
                    node.getChildByName("tips").getComponent(cc.Label).string = item.descript
                    node.getChildByName("install")["downloadUrl"] = item.download
                    node.parent = this.nodeContent
                }
            });
        }.bind(this))
        EnterSoundManager.playSound("enter_xiufu")
    }

    onDestroy () {
        this.nodeTemplate.destroy()
    }

    onBtnClick (event, userData) {
        if (userData === "close") {
            this.node.destroy()
        }else if (userData === "install") {
            let url = event.target.downloadUrl || ""
            url.substr(0, 4) !== "http" && (url = "http://" + url)
            cc.sys.openURL(url)
        }
    }
}
